// Incentive feature color palette
// Centralized here for easy maintenance and future theme migration

import { SHIFT_CONFIG_COLORS } from "@/shared/components/KPICard";

// --- Color pair type ---
export type ColorPair = { bg: string; text: string };

// --- 6-zone color lookup (uses same palette as KPICard) ---

export interface SixZoneThresholds {
	Red: number;
	Orange: number;
	Yellow: number;
	GreenSoft: number;
	GreenNormal: number;
	GreenHard: number;
}

// --- Text colors ---
export const TEXT = {
	primary: "#333", // dark gray
	secondary: "#555", // medium gray
	tertiary: "#666", // medium-light gray
	disabled: "#aaa", // light gray
	inProgress: "#1565c0", // blue
	white: "#fff", // white
} as const;

export const GRAY_COLOR: ColorPair = { bg: "#e0e0e0", text: "#757575" };

const ZONE_COLORS: ColorPair[] = [
	{ bg: SHIFT_CONFIG_COLORS.greenHard, text: TEXT.white },
	{ bg: SHIFT_CONFIG_COLORS.greenNormal, text: TEXT.white },
	{ bg: SHIFT_CONFIG_COLORS.greenSoft, text: TEXT.white },
	{ bg: SHIFT_CONFIG_COLORS.yellow, text: TEXT.primary },
	{ bg: SHIFT_CONFIG_COLORS.orange, text: TEXT.primary },
	{ bg: SHIFT_CONFIG_COLORS.red, text: TEXT.white },
];

export const getZoneColor = (
	value: number | null,
	t: SixZoneThresholds,
): ColorPair => {
	if (value == null) return GRAY_COLOR;
	if (value >= t.GreenHard) return ZONE_COLORS[0];
	if (value >= t.GreenNormal) return ZONE_COLORS[1];
	if (value >= t.GreenSoft) return ZONE_COLORS[2];
	if (value >= t.Yellow) return ZONE_COLORS[3];
	if (value >= t.Orange) return ZONE_COLORS[4];
	return ZONE_COLORS[5];
};

// --- Row tint backgrounds (Daily Summary) ---
export const ROW_TINTS = {
	override: "#fff8e1", // pale amber
	current: "#e3f2fd", // pale blue
	total: "#f5f5f5", // light gray
} as const;

// --- Surface colors ---
export const SURFACE = {
	border: "#e0e0e0", // light gray
	borderLight: "#ccc", // lighter gray
	background: "#fafafa", // off-white
} as const;
